export default __webpack_public_path__ + "static/media/average-waiver-flyer-2026.26f47318.pdf";